export const copyToClipboard = async (text: string): Promise<boolean> => {
    if (navigator.clipboard) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (err) {
            // eslint-disable-next-line
            console.error('Failed to copy: ', err);
            return false;
        }
    }
    return false;
};
